import './App.css';
import React, { useState } from 'react';
import SignaturePad from './SignaturePad';

function App() {
  const [signature, setSignature] = useState(null);
  return (
    <div>
      <h1>Unterschrift erfassen</h1>

      <SignaturePad
        onSave={(data) => {
          console.log('Signatur gespeichert:', data);
          setSignature(data);
        }}
        onClear={() => setSignature(null)}
      />

      {signature && (
        <div>
          <h2>Gespeicherte Unterschrift:</h2>
          <img
            src={signature}
            alt="Gespeicherte Unterschrift"
            style={{ maxWidth: '300px' }}
          />
        </div>
      )}
    </div>
  );
}

export default App;